(function () {
  'use strict';

  function initAddAll(btn) {
    btn.addEventListener('click', function () {
      var ids = (btn.dataset.variantIds || '').split(',').filter(Boolean);
      if (!ids.length) return;
      btn.disabled = true;
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        })
        .then(function () {
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  }

  document.querySelectorAll('[data-guide-add-all]').forEach(initAddAll);
})();
